import {Injectable, Injector} from "@angular/core";
import {CleverreportStoreState} from "../cleverreport.store.module";
import {Store} from "@ngrx/store";
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import {Observable} from "rxjs/Observable";
import {LocationEntity} from "./location.entity";
import {LocationActions} from "./location.actions";

@Injectable()
export class LocationService {

  private databaseProvider;

  constructor(private store: Store<CleverreportStoreState>, private injector: Injector) {
    setTimeout(() => {
      this.databaseProvider = injector.get(DataProvider);
    })
  }

  addAll(locations: Array<LocationEntity>, synced: boolean = true): void {
    if (!synced) {
      for (let location of locations) {
        if (!location.hasOwnProperty('_id')) {
          this.databaseProvider.createDocumentWithoutInit(location)
            .then((location: LocationEntity) => {
              this.store.dispatch(LocationActions.add(location));
            });
        }
      }
    } else {
      this.store.dispatch(LocationActions.addAll(locations));
    }
  }

  add(location: LocationEntity, synced: boolean = true): void {
    if (!synced) {
      this.databaseProvider.createDocumentWithoutInit(location)
        .then((location: LocationEntity) => {
          this.store.dispatch(LocationActions.add(location));
        });
    } else {
      this.store.dispatch(LocationActions.add(location));
    }
  }

  set(location: LocationEntity, synced: boolean = true): void {
    if (!synced) {
      this.databaseProvider.updateDocument(location)
        .then((location: LocationEntity) => {
          this.store.dispatch(LocationActions.set(location));
        });
    } else {
      this.store.dispatch(LocationActions.set(location));
    }
  }

  remove(location: LocationEntity, synced: boolean = true): void {
    if (!synced) {
      this.databaseProvider.softDeleteDocument(location)
        .then(() => {
          this.store.dispatch(LocationActions.remove(location._id));
        });
    } else {
      this.store.dispatch(LocationActions.remove(location._id));
    }
  }

  getById(id: string): Observable<LocationEntity> {
    return this.store.select('locations').map((locations: Array<LocationEntity>) => {
      return locations.find((location: LocationEntity) => {
        return location._id === id;
      });
    });
  }

  public getAll(): Observable<Array<LocationEntity>> {
    return this.store.select('locations').map((locations: Array<LocationEntity>) => {
      return locations.filter((location: LocationEntity) => {
        return !location.hasOwnProperty('_deleted') && (!location.hasOwnProperty('deleted') || !location.deleted);
      })
    })
  }

  public getByCustomerId(customerId: number | string): Observable<Array<LocationEntity>>{
    return this.getAll().map((locations: Array<LocationEntity>) => {
      return locations.filter((location: LocationEntity) => {
        return location.customerId == customerId;
      })
    });
  };
}



// WEBPACK FOOTER //
// ./src/store/location/location.service.ts